export const handleApiError = (
  error,
  navigate,
  showErrorToast,
  redirectPath = "/signin",
) => {
  const status = error.response?.status;
  const message = error.response?.data?.message;

  // CHECK (expiry / invalid token) Unauthorized
  if (status === 401) {
    showErrorToast?.(message);

    localStorage.clear();
    if (navigate) {
      setTimeout(() => {
        navigate(redirectPath);
      }, 1500);
    }

    return;
  }

  // Backend message
  if (message) {
    showErrorToast?.(message);
    return;
  }

  // fallback
  showErrorToast?.("Network error! Please try again.");
};
